/*!
 * jQuery lightweight Fly to
 * Author: @ElmahdiMahmoud
 * Licensed under the MIT license
 */

// self-invoking
(function ($, window, document, undefined) {
  $.fn.flyto = function (options) {
    // Establish default settings

    var settings = $.extend(
      {
        item: '.flyto-item',
        target: '.flyto-target',
        fixTarget: '.flyto-fix-target',
        mbTarget: '.flyto-mb-target',
        button: '.flyto-btn',
        specialElToDrag: '',
        shake: true,
      },
      options
    );

    return this.each(function () {
      var $this = $(this),
        flybtn = $this.find(settings.button),
        target = $(settings.target),
        fixTarget = $(settings.fixTarget),
        mbTarget = $(settings.mbTarget),
        itemList = $this.find(settings.item);

      $(document)
        .find(this)
        .on('click', settings.button, function () {
          let _this = $(this);
          let eltoDrag = null;
          if (settings.specialElToDrag === '') {
            eltoDrag = _this
              .parent()
              .parent()
              .parent()
              .parent()
              .find('.product-grid-image')
              .find('img')
              .first()
              .eq(0);
          } else {
            eltoDrag = $(settings.specialElToDrag).first().eq(0);
          }
          if (eltoDrag) {
            let actualTarget = null;
            if ($(fixTarget).is(':visible')) {
              actualTarget = fixTarget;
            } else if ($(mbTarget).is(':visible')) {
              actualTarget = mbTarget;
            } else if ($(target).is(':visible')) {
              actualTarget = target;
            }

            if (actualTarget === null) {
              if (settings.shake) {
                setTimeout(function () {
                  actualTarget.effect(
                    'shake',
                    {
                      times: 2,
                    },
                    200
                  );
                }, 1000);
              }
            } else {
              var imgclone = eltoDrag
                .clone()
                .offset({
                  top: eltoDrag.offset().top,
                  left: eltoDrag.offset().left,
                })
                .css({
                  opacity: '0.5',
                  position: 'absolute',
                  height: eltoDrag.height() / 2,
                  width: eltoDrag.width() / 2,
                  'z-index': '9999',
                })
                .appendTo($('body'))
                .animate(
                  {
                    top: actualTarget.offset().top + 10,
                    left: actualTarget.offset().left + 15,
                    height: eltoDrag.height() / 2,
                    width: eltoDrag.width() / 2,
                  },
                  1000,
                  'easeInOutExpo'
                );

              if (settings.shake) {
                setTimeout(function () {
                  actualTarget.effect(
                    'shake',
                    {
                      times: 2,
                    },
                    200
                  );
                }, 1500);
              }

              imgclone.animate(
                {
                  width: 0,
                  height: 0,
                },
                function () {
                  $(this).detach();
                }
              );
            }
          }
        });
    });
  };
})(jQuery, window, document);
